import React from "react";
import { NavLink, Outlet, Route, Routes } from "react-router-dom";

import Statistics from "./Statistics";
import UserActivity from "./UserActivity";
import ReflectionTrend from "./ReflectionTrend";

export default function StatisticsOverview() {
    return (
        <Routes>
          <Route path="/*" element={<Layout />}>
            <Route index element={<View view="statistics" />} />
            <Route path="statistics" element={<View view="statistics" />} />
            <Route path="useractivity" element={<View view="useractivity" />} />
            <Route path="reflectiontrend" element={<View view="reflectiontrend" />} />
          </Route>
        </Routes>
      )
}

function Layout(props) {
    return (
      <>
        <section className='spaceBetween flexCenter orgTop'>
          <h3>Statistics</h3>
        </section>
        <div className='grid-container nowrap'>
          <nav className="organisationMenu">
            <ul className="nav">
              <li>
                <NavLink to="" end className={({ isActive }) =>
                  isActive ? 'active' : undefined
                }>Statistics</NavLink>
              </li>
              <li>
                <NavLink to="reflectiontrend" className={({ isActive }) =>
                  isActive ? 'active' : undefined
                }>Reflection trend</NavLink>
              </li>
              <li>
                <NavLink to="useractivity" className={({ isActive }) =>
                  isActive ? 'active' : undefined
                }>User activity</NavLink>
              </li>
            </ul>
          </nav>
          <div>
            <Outlet />
          </div>
        </div>
      </>
    )
  }

function View(props) {
    const { view } = props;
    switch (view) {
      case 'statistics':
        return (<React.Suspense fallback={<p>Loading...</p>}><section><Statistics /></section></React.Suspense>);
      case 'useractivity':
        return (<React.Suspense fallback={<p>Loading...</p>}><section><UserActivity /></section></React.Suspense>);
      case 'reflectiontrend':
        return (<React.Suspense fallback={<p>Loading...</p>}><section><ReflectionTrend /></section></React.Suspense>);
      default:
        return (<React.Suspense fallback={<p>Loading...</p>}><section><Statistics /></section></React.Suspense>);
    }
  }